<script lang="ts" setup>
import type { ComponentElementsLinkWrapper } from '@autobid/strapi-integration/graphql/graphql'
import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useToken } from '@autobid/nuxt-auth/src/composables/useToken'
import { useUserHasBidBlocked } from '@autobid/ui/composables/useIsUserHasBidBlocked'
import { usePageHeader } from '@autobid/ui/composables/usePageHeader'
import { onMounted, ref } from 'vue'

defineProps<Props>()

const bidBlockedBtn = ref<HTMLButtonElement>()

interface Props {
  data: ComponentElementsLinkWrapper
}

const { isAuthed, signOut } = useAutobidAuth()
const { tokenData } = useToken()
const { openReasonOnAuthorize } = usePageHeader()
const isBidBlocked = useUserHasBidBlocked()

onMounted(() => {
  if (bidBlockedBtn.value) {
    openReasonOnAuthorize(bidBlockedBtn.value)
  }
})
</script>

<template>
  <layout-header-partials-link
    v-if="isAuthed && tokenData"
    class="items-center"
    as="button"
    @link-click="() => signOut()"
  >
    {{ data.text }}

    <template v-if="data.icon" #icon>
      <CommonIcon :name="data.icon" class="h-9 w-9" />
    </template>

    <template #beforeLink>
      <span class="mr-3.5 hidden lg:block">
        {{ tokenData.nickname }}
      </span>
    </template>

    <template #afterLink>
      <span v-if="isAuthed && isBidBlocked">
        <common-dropdown x="left">
          <template #button="{ open }">
            <div
              ref="bidBlockedBtn"
              :data-open="open"
              class="ml-4 text-red"
            >
              <CommonIconBlock />
            </div>
          </template>

          <template #items>
            <LayoutHeaderPartialsBiddingBlockedReason />
          </template>
        </common-dropdown>
      </span>
    </template>
  </layout-header-partials-link>
</template>
